<template>
  <div class='main'>
    <div style="text-align:right;padding:10px 20px 10px 10px">
      <Button
        icon="md-trash"
        @click="delfeed"
      >
        删除
      </Button>
    </div>
    <el-table
      :data="tableData"
      stripe
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
      >
      </el-table-column>
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        label="主题"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="content"
        label="内容"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="contacts"
        label="联系人"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        label="电话"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createdate"
        label="反馈时间"
        align="center"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Table from '../../components/table'
import Api from '../../api/index'

export default {
  data () {
    return {
      tableData: [],
      pageindex: 1,
      pagesize: 20,
      total: 1,
      delList: []
    }
  },
  created () {
    this.GetDataList()
  },
  components: {
    Table,
  },
  methods: {
    getcurrentpage (val) {
      this.pageindex = val
    },
    //获取反馈列表
    async GetDataList () {
      const res = await Api.BaseFeedback.GetDataList(this.pageindex, this.pagesize)
      if (res.success != true) return this.Message.info(res.msg)
      this.tableData = res.rows
      this.total = res.total
    },
    handleSelectionChange (e) {
      this.delList = []
      for (let i = 0; i < e.length; i++) {
        const element = e[i];
        this.delList.push(element.feedbackid)
      }
    },
    //删除反馈
    async delfeed () {
      const res = await Api.BaseFeedback.DelData(this.delList)
      if (res.success != true) return this.$message.info(res.msg)
      this.GetDataList()
    }
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px;
}
</style>